import { useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { validationFunctions } from "../utils/validationFunctions";

type UseValidationOptions = {
  validation?: string;
};

export default function useValidation({ validation }: UseValidationOptions) {
  const { getValues } = useFormContext();

  const prepareArgumentValues = useCallback(
    (args?: string[]) =>
      args?.map((arg) => (/^\$/.test(arg) ? getValues(arg.slice(1)) : arg)) ??
      [], // arg.slice(1) remove $ at the first
    [getValues]
  );

  const validate = useMemo(() => {
    if (!validation?.length) return undefined;

    const validationStrings = validation?.split("|");
    if (!validationStrings?.length) return undefined;

    const validationRules = validationStrings.reduce((acc, curr) => {
      const [operation, args] = curr.split(":") as [string, string | undefined];
      if (!validationFunctions[operation])
        throw new Error(
          `"${operation}" is not valid, Available validations (${Object.keys(
            validationFunctions
          ).join(", ")})`
        );

      acc[operation] = (v: any) =>
        validationFunctions[operation](
          v,
          ...prepareArgumentValues(args?.split(","))
        );
      return acc;
    }, {} as Record<string, any>);

    return validationRules;
  }, [validation, prepareArgumentValues]);

  return validate;
}
